import { render, staticRenderFns } from "./DisconectSat.vue?vue&type=template&id=dbf487ee&scoped=true"
import script from "./DisconectSat.vue?vue&type=script&lang=js"
export * from "./DisconectSat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf487ee",
  null
  
)

export default component.exports